import { forwardRef, Dispatch, SetStateAction } from "react";
import styled, { css } from "styled-components/macro";
import { THEME_COLOR } from "../vars";

const Switch = forwardRef<
  HTMLLabelElement,
  {
    value: boolean;
    onChange: Dispatch<SetStateAction<any>>;
    leftLabel: string;
    rightLabel: string;
    leftValue?: any;
    rightValue?: any;
  }
>(function Switch(
  {
    value,
    onChange,
    leftLabel,
    rightLabel,
    leftValue = false,
    rightValue = true,
    ...props
  },
  ref
) {
  const isChecked = value === rightValue;
  return (
    <SwitchContainer flip={Boolean(leftLabel && rightLabel)} ref={ref}>
      <span>{leftLabel}</span>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() => onChange(isChecked ? leftValue : rightValue)}
        {...props}
      />
      <div />
      <span>{rightLabel}</span>
    </SwitchContainer>
  );
});

const SwitchContainer = styled.label<{ flip?: boolean }>`
  display: inline-block;
  & > input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  & > div {
    transition-duration: 0.1s;
    background: ${THEME_COLOR};
    width: 40px;
    height: 18px;
    border-radius: 1000px;
    position: relative;
    margin-left: 1ch;
    margin-right: 1ch;
    display: inline-block;
    vertical-align: middle;
    &:after {
      transition-duration: 0.1s;
      display: block;
      content: "";
      height: 14px;
      width: 14px;
      border-radius: 1000px;
      position: absolute;
      top: 2px;
      background: white;
    }
  }
  & > input:checked + div:after {
    left: calc(100% - 16px);
  }
  & > input:not(:checked) + div:after {
    left: 2px;
  }
  & > input:focus + div {
    box-shadow: 0px 0px 0px 2px ${THEME_COLOR}33;
  }
  ${(p) =>
    !p.flip &&
    css`
      & > input:not(:checked) + div {
        background: #ccc;
      }
    `}
  &>span {
    display: inline-block;
    text-align: center;
    width: 80px;
    &:first-child {
      text-align: right;
    }
    &:last-child {
      text-align: left;
    }
  }
`;

export default Switch;
